export type MessagingThreadMessageDateCategoryDisplayProps = {
    display: string;
    ref?: React.RefObject<HTMLDivElement | null>;
}

export default function MessagingThreadMessageDateCategoryDisplay({ display, ref }: MessagingThreadMessageDateCategoryDisplayProps) {
    return (
        <div className="flex justify-center">
            <div ref={ref} className="text-[11px] text-gray-500 border border-gray-300 rounded-[4px] px-[15px] py-[3px] my-[12px] bg-gray-50/90">
                {display}
            </div>
        </div>
    );
}